export default __webpack_public_path__ + "static/media/Partizan of Red Ruin.589c1cac.jpg";